<template>
  <div>
    <div class="operations">
      <div style="flex:1"></div>
      <a-button @click="showForm = true">添加</a-button>
    </div>
    <GigaTable :gData="dataSource" :gColumns="columns" :gInnerColumns="innerColumns" />
    <VehicleFilmsForm :visible="showForm" :formData="formState" :filmCategory="filmCategory" @formCancel="handleCancel" @formOk="handleOk" /> 
    <OutlookDiyForm :visible="showOutlookDiyForm" :formData="formState" @formCancel="handleCancel" @formOk="handleOk($event, 'outlook')" /> 
  </div>
</template>
<script>
import { getOutlookDiy, editFilm, getVehicleFilmCategory, editOutlookDiy, getVehicleFilms } from '../http/api'
import GigaTable from '../components/GigaTable.vue'
import VehicleFilmsForm from '../components/form/VehicleFilmsForm'
import OutlookDiyForm from '../components/form/OutlookDiyForm'

export default {
  components: {
    GigaTable,
    VehicleFilmsForm,
    OutlookDiyForm
  },
  data() {
    return {
      showOutlookDiyForm: false,
      showForm: false,
      formState: {},
      dataSource: [],
      filmCategory: [],
      columns: [{
        title: 'id',
        dataIndex: 'id',
        key: 'id',
        width: 80
      }, {
        title: '名称',
        dataIndex: 'name',
        key: 'name'
      }, {
        title: '色系',
        dataIndex: 'color',
        key: 'color'
      }, {
        title: '所属分类',
        dataIndex: 'filmCategory',
        key: 'filmCategory',
        customRender: (val) => {
          return <span v-html={val.value && val.value.name || ''}></span>
        }
      }, {
        title: '是否新增',
        dataIndex: 'isNew',
        key: 'isNew',
        customRender: (val) => {
          return <span v-html={val.value ? '是' : '否'}></span>
        }
      }, {
        title: '排序',
        dataIndex: 'displayOrder',
        key: 'displayOrder'
      }, {
        title: '是否发布',
        dataIndex: 'isPublished',
        key: 'isPublished',
        customRender: val => <span v-html={val.value ? '已发布' : '未发布'} />
      }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        width: 200,
        customRender: (val) => {
          return (
            <div>
              <a-dropdown trigger={['click']} overlay={(
                <a-menu>
                  <a-menu-item onClick={() => this.editFilm(val.record)}>
                    <span>编辑</span>
                  </a-menu-item>
                  <a-menu-item onClick={() => this.editFilm(val.record, 'publish')}>
                    <span v-html={val.record.isPublished ? '取消发布' : '发布'}></span>
                  </a-menu-item>
                  <a-menu-item onClick={() => this.editFilm(val.record, 'del')}>
                    <span>删除</span>
                  </a-menu-item>
                </a-menu>
              )}>
                <a-button>操作</a-button>
              </a-dropdown>
              <a-button onClick={() => this.addOutlookDiy(val.record)} style="margin-left:10px">添加车图</a-button>
            </div>
          )
        }
      }],

      innerColumns: [{
        title: 'id',
        dataIndex: 'id',
        key: 'id',
        width: 80
      }, {
        title: '车型',
        dataIndex: 'carType',
        key: 'carType'
      }, {
        title: '前视角',
        dataIndex: 'quickView',
        key: 'quickView1',
        customRender: val => {
          return <img src={val.value && val.value[0] && val.value[0].image && val.value[0].image.url || ''} style="width: 40px" />
        }
      }, {
        title: '侧视角',
        dataIndex: 'quickView',
        key: 'quickView2',
        customRender: val => {
          return <img src={val.value && val.value[1] && val.value[1].image && val.value[1].image.url || ''} style="width: 40px" />
        }
      }, {
        title: '是否发布',
        dataIndex: 'isPublished',
        key: 'isPublished',
        customRender: val => <span v-html={val.value ? '已发布' : '未发布'} />
      }, {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        width: 200,
        customRender: (val) => {
          return (
            <div>
              <a-dropdown trigger={['click']} overlay={(
                <a-menu>
                  <a-menu-item onClick={() => this.editOutlookDiy(val.record)}>
                    <span>编辑</span>
                  </a-menu-item>
                  <a-menu-item onClick={() => this.editOutlookDiy(val.record, 'publish')}>
                    <span v-html={val.record.isPublished ? '取消发布' : '发布'}></span>
                  </a-menu-item>
                  <a-menu-item onClick={() => this.editOutlookDiy(val.record, 'del')}>
                    <span>删除</span>
                  </a-menu-item>
                </a-menu>
              )}>
                <a-button>操作</a-button>
              </a-dropdown>
            </div>
          )
        }
      }]
    }
  },
  created() {
    this.getVehicleFilms()
    this.getVehicleFilmCategory()
  },
  methods: {
    setImg(e, type) {
      let img = e[0]
      let formState = this.formState
      formState[type] = img.url
      this.formState = JSON.parse(JSON.stringify(formState))
    },
    handleOk(formState, type) {
      if (type == 'outlook') {
        editOutlookDiy({variables: formState}).then(res => {
          console.log(res)
          this.handleCancel()
          this.getVehicleFilms()
        }).catch(err => {
          console.log(err)
        })
      } else {
        editFilm({variables: formState}).then(res => {
          console.log(res)
          this.handleCancel()
          this.getVehicleFilms()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    editOutlookDiy(record, type) {
      console.log(type)
      if (type == 'del') {
        this.handleOk({id: record.id, isDeleted: true}, 'outlook')
      } else if (type == 'publish') {
        this.handleOk({id: record.id, isPublished: !record.isPublished}, 'outlook')
      } else { 
        record.quickView1 = record.quickView && record.quickView[0] && record.quickView[0].image && record.quickView[0].image.id || ''
        record.quickView1Url = record.quickView && record.quickView[0] && record.quickView[0].image && record.quickView[0].image.url || ''
        record.quickView2 = record.quickView && record.quickView[1] && record.quickView[1].image && record.quickView[1].image.id || ''
        record.quickView2Url = record.quickView && record.quickView[1] && record.quickView[1].image && record.quickView[1].image.url || ''
        record.carType = `m${(record.carType).split(' ')[1].toLocaleLowerCase()}`
        this.formState = record
        this.showOutlookDiyForm = true
      }
    },
    editFilm(record, type) {
      if (type == 'del') {
        this.handleOk({id: record.id, isDeleted: true})
      } else if (type == 'publish') {
        this.handleOk({id: record.id, isPublished: !record.isPublished})
      } else {
        this.formState = record
        this.formState.filmCategoryId = record.filmCategory && record.filmCategory.id || ''
        this.showForm = true
      }
    },
    addOutlookDiy(record) {
      console.log(record)
      let formState = this.formState
      formState.filmId = record.id
      this.showOutlookDiyForm = true
    },
    handleCancel() {
      this.showForm = false
      this.showOutlookDiyForm = false
      this.formState = {}
    },
    getVehicleFilms() {
      Promise.all([getVehicleFilms(), getOutlookDiy()]).then(res => {
        if (res.errors) {
          this.$message.error(res.errors[0].message)
          return
        }
        console.log(res)
        let outlookDiyItems = res[1].data.outlookDiy.items
        let vehicleFilms = res[0].data.vehicleFilms
        vehicleFilms.forEach(e => {
          outlookDiyItems.forEach(el => {
            if (el.film.id == e.id) {
              e.innerData = e.innerData ? e.innerData : []
              e.innerData.push(el)
            }
          })
        })
        let dataSource = vehicleFilms
        console.log(dataSource)
        this.dataSource = dataSource
      })
    },
    getVehicleFilmCategory() {
      getVehicleFilmCategory().then(res => {
        if (res.errors) {
          this.$message.error(res.errors[0].message)
          return
        }
        let dataSource = res.data.vehicleFilmCategory
        this.filmCategory = dataSource
      })
    }
  },
}
</script>
<style lang="scss" scoped>
  
</style>